<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <GiftForm
          v-model="gift"
          title="Nový dárek"
          :edit="false"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import GiftForm from '@/components/forms/GiftForm'

export default {
  name: 'GiftAdd',
  components: {
    GiftForm,
  },
  data() {
    return {
      gift: {
        promoCodeApplyCount: 1,
      },
      loading: false,
      saving: false,
    }
  },
  methods: {
    ...mapActions({
      getGift: 'gift/getGift',
      createGift: 'gift/createGift',
    }),
    save() {
      this.saving = true
      this.createGift(this.gift)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'gifts.detail',
              params: { giftId: response.data.id },
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
